// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import $ from 'axios'
import store from '../store'
import MockAdapter from 'axios-mock-adapter'

export const api = $.create({
  timeout: 60 * 1000,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

if (process.env.NODE_ENV === 'development') {
  console.log('=====mock=====')
  const mock = require('../mock')
  mock.default(new MockAdapter(api, { onNoMatch: 'passthrough' }))
}

api.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT

export const setAPIEndPoint = endPoint => {
  api.defaults.baseURL = endPoint
}
export const setAPIAuthHeader = token => {
  api.defaults.headers.common['X-Karta-Token'] = token
}
export const setAPIAuthType = type => {
  api.defaults.headers.common.AuthType = type
}
export const clearAPIAuthHeader = () => {
  api.defaults.headers.common['X-Karta-Token'] = null
}

function buildQueryStringItem (key, value) {
  return `${key}=${value}`
}
api.defaults.paramsSerializer = function (params) {
  const qs = []
  Object.keys(params).forEach(k => {
    if (Array.isArray(params[k]) && params[k].length > 0) {
      qs.push(params[k].map(d => buildQueryStringItem(k, d)).join('&'))
    } else if (!Array.isArray(params[k]) && params[k] !== null && params[k] !== undefined) {
      qs.push(buildQueryStringItem(k, params[k]))
    }
  })
  return qs.join('&')
}

api.interceptors.request.use(config => {
  // config.baseURL = 'http://localhost:8080'
  return config
})
api.interceptors.response.use(
  res => {
    return res.data
  },
  err => {
    if (err.response && err.response.status === 401) {
      store.dispatch({ type: 'auth/invalidToken' })
    }
    //   if (err.response && err.response.data) {
    //     // if err.response.data is json
    //     if (typeof err.response.data === 'string') {
    //       let responseError
    //       try {
    //         responseError = JSON.parse(err.response.data)
    //       } catch (e) {}
    //       if (responseError && responseError.message) {
    //         throw new Error(err.response.statusText + responseError.message)
    //       }
    //     }
    //     if (err.response.data && err.response.data.message) {
    //       throw new Error(err.response.statusText + err.response.data.message)
    //     }
    //     throw new Error(err.response.statusText + err.response.data.toString())
    //   }
    throw err?.response?.data
  }
)
